module.exports = {"phone_number_placeholder":"+44 150 0000 0000"}


//////////////////
// WEBPACK FOOTER
// ./src/app/@propnow/locales/en-GB.json
// module id = 448
// module chunks = 260